import React from 'react';
import './SmsConsentNotice.css';

export const SMS_CONSENT_VERSION = 't6-campaign-v2';
export const SMS_CONSENT_BODY = (
  'By providing your mobile number, you agree to receive KeyFlo Text Messages, '
  + 'including meeting confirmations and reminders, support, and billing and account replies. '
  + 'Msg freq may vary. Std msg & data rates apply. '
  + 'We will not share or sell your mobile information for marketing or promotional purposes.'
);
export const SMS_CONSENT_TERMS_LABEL = 'Terms & Conditions';
export const SMS_CONSENT_PRIVACY_LABEL = 'Privacy Docs';
export const SMS_CONSENT_TERMS_HREF = 'https://keyflo.ai/terms';
export const SMS_CONSENT_PRIVACY_HREF = 'https://keyflo.ai/privacy';
export const SMS_CONSENT_TEXT = (
  SMS_CONSENT_BODY
  + '\n'
  + SMS_CONSENT_TERMS_LABEL
  + '\n'
  + SMS_CONSENT_PRIVACY_LABEL
);

const SmsConsentNotice = ({ source }) => (
  <p
    className="sms-consent-notice"
    data-sms-consent={source}
    data-consent-version={SMS_CONSENT_VERSION}
  >
    {SMS_CONSENT_BODY}
    <br />
    <a href={SMS_CONSENT_TERMS_HREF} target="_blank" rel="noopener noreferrer">
      {SMS_CONSENT_TERMS_LABEL}
    </a>
    <br />
    <a href={SMS_CONSENT_PRIVACY_HREF} target="_blank" rel="noopener noreferrer">
      {SMS_CONSENT_PRIVACY_LABEL}
    </a>
  </p>
);

export default SmsConsentNotice;
